import {createAction} from 'web-app/util/redux/typed-action-helpers';

import {DOMAIN} from './constants';

export const {action: setRoleInvitationRelationIdsForAChild} = createAction(
    `${DOMAIN}/SET_ROLE_INVITATION_RELATION_IDS_FOR_A_CHILD`,
    (childId: string, roleInvitationRelationIds: Array<string>) => ({
        childId,
        roleInvitationRelationIds,
    }),
);

export const {action: removeRoleInvitationRelationIdForAChild} = createAction(
    `${DOMAIN}/REMOVE_ROLE_INVITATION_RELATION_ID_FOR_A_CHILD`,
    (childId: string, roleInvitationRelationId: string) => ({
        childId,
        roleInvitationRelationId,
    }),
);

export const {action: addRoleInvitationRelationIdForAChild} = createAction(
    `${DOMAIN}/ADD_ROLE_INVITATION_RELATION_ID_FOR_A_CHILD`,
    (childId: string, roleInvitationRelationId: string) => ({
        childId,
        roleInvitationRelationId,
    }),
);
